const Config = {
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT as string,
  emailBaseUrl: process.env.NEXT_PUBLIC_EMAIL_BASE_URL as string,
  getStartedUrl: process.env.NEXT_PUBLIC_GET_STARTED_URL as string,
  sanity: {
    projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID as string,
    dataset: process.env.NEXT_PUBLIC_SANITY_DATASET as string,
  },
};

export default Config;
